(function(){
'use strict';
const $=(s,c=document)=>c.querySelector(s);
const $$=(s,c=document)=>[...c.querySelectorAll(s)];
const on=(el,ev,fn)=>el&&el.addEventListener(ev,fn);
const isPage=(...t)=>t.some(p=>document.body.classList.contains('template-'+p));

function initNavCleanup(){
  $$('.site-nav__item,.header__nav-item').forEach(item=>{
    const link=item.querySelector('a');
    if(!link)return;
    const txt=link.textContent.trim().toUpperCase();
    if(txt.includes('SUIVI COMMANDE')||txt==='ACCUEIL'||txt==='TOUS NOS PRODUITS')item.style.display='none';
  });
}

function initFAQ(){
  if(!isPage('product'))return;
  const desc=$('.product__description,.product-description,[class*="product-description"]');
  if(!desc)return;
  const faqs=[
    {q:'Mati\u00e8re & composition',a:'Retrouvez la composition exacte dans la description ci-dessus. Toutes nos pi\u00e8ces sont fabriqu\u00e9es avec des mat\u00e9riaux s\u00e9lectionn\u00e9s pour leur qualit\u00e9 et leur durabilit\u00e9.'},
    {q:'Guide des tailles',a:'Nos pi\u00e8ces taillent normalement. En cas de doute entre deux tailles, optez pour la plus grande.'},
    {q:'Livraison & d\u00e9lais',a:'France\u00a0: 3-5 jours ouvr\u00e9s. International\u00a0: 5-10 jours ouvr\u00e9s. Exp\u00e9dition sous 24-48h apr\u00e8s commande.'},
    {q:'Retours & \u00e9changes',a:'Retours accept\u00e9s sous 14 jours. Article non port\u00e9, \u00e9tiquettes d\'origine attach\u00e9es. Contact\u00a0: malangebrand@gmail.com'},
    {q:'Paiement s\u00e9curis\u00e9',a:'Paiement 100% s\u00e9curis\u00e9 via Shopify Payments. CB, PayPal, Apple Pay, Google Pay accept\u00e9s.'},
  ];
  const wrap=document.createElement('div');
  wrap.className='ma-faq';
  wrap.innerHTML='<div class="ma-faq-title">Informations</div>';
  faqs.forEach(f=>{
    const item=document.createElement('div');
    item.className='ma-faq-item';
    item.innerHTML=`<button class="ma-faq-q" aria-expanded="false"><span>${f.q}</span><span class="ma-faq-icon">+</span></button><div class="ma-faq-a">${f.a}</div>`;
    const btn=item.querySelector('.ma-faq-q'),ans=item.querySelector('.ma-faq-a');
    on(btn,'click',()=>{
      const open=btn.getAttribute('aria-expanded')==='true';
      $$('.ma-faq-q').forEach(b=>{b.setAttribute('aria-expanded','false');b.querySelector('.ma-faq-icon').textContent='+'});
      $$('.ma-faq-a').forEach(a=>{a.style.maxHeight='0';a.style.opacity='0';});
      if(!open){btn.setAttribute('aria-expanded','true');btn.querySelector('.ma-faq-icon').textContent='\u2212';ans.style.maxHeight=ans.scrollHeight+'px';ans.style.opacity='1';}
    });
    wrap.appendChild(item);
  });
  desc.insertAdjacentElement('afterend',wrap);
}

function initBundleSuggestion(){
  if(!isPage('product'))return;
  const isHS=window.location.href.toLowerCase().includes('highschool')||document.title.toLowerCase().includes('highschool');
  if(!isHS)return;
  const pieces=[
    {name:'Varsity Jacket',price:'129,90 \u20ac',url:'/products/varsity-jacket-highschool',img:'https://cdn.shopify.com/s/files/1/0102/7460/3055/files/16-removebg-preview.png?v=1754519783'},
    {name:'Tee-Shirt',price:'22,90 \u20ac',url:'/collections/highschool',img:'https://cdn.shopify.com/s/files/1/0102/7460/3055/files/10-removebg-preview.png?v=1754519832'},
    {name:'Casquette',price:'17,90 \u20ac',url:'/collections/highschool',img:'https://cdn.shopify.com/s/files/1/0102/7460/3055/files/1_1.png?v=1735747553'},
  ];
  const cur=$('h1.title,.product__title')?.textContent?.trim().toLowerCase()||'';
  const others=pieces.filter(p=>!cur.includes(p.name.toLowerCase())).slice(0,3);
  if(others.length<2)return;
  const wrap=document.createElement('div');
  wrap.className='ma-bundle';
  wrap.innerHTML=`<div class="ma-bundle-header"><span class="ma-bundle-title">Compl\u00e9ter la tenue</span><span class="ma-bundle-sub">Collection Highschool</span></div><div class="ma-bundle-items">${others.map(p=>`<a href="${p.url}" class="ma-bundle-item"><div class="ma-bundle-img"><img src="${p.img}" alt="${p.name}" loading="lazy"></div><div class="ma-bundle-name">${p.name}</div><div class="ma-bundle-price">${p.price}</div></a>`).join('<div class="ma-bundle-plus">+</div>')}</div><a href="/collections/highschool" class="ma-bundle-cta">Voir le pack complet \u2192</a>`;
  const form=$('[data-product-form],.product-form,form[action*="/cart/add"]');
  if(form)form.insertAdjacentElement('afterend',wrap);
}

function initPackagingSection(){
  if(!isPage('index'))return;
  if($('.ma-packaging'))return;
  const sec=document.createElement('div');
  sec.className='ma-packaging';
  sec.innerHTML=`<div class="ma-pkg-content"><div class="ma-pkg-text"><div class="ma-pkg-label">L'exp\u00e9rience MalAnge</div><div class="ma-pkg-title">Du drop<br>\u00e0 ta porte</div><div class="ma-pkg-body">Chaque commande MalAnge est emball\u00e9e avec soin. Packaging soign\u00e9, \u00e9dition num\u00e9rot\u00e9e, pr\u00eat \u00e0 \u00eatre port\u00e9.</div><div class="ma-pkg-features"><div class="ma-pkg-feat"><span>\u2726</span> Packaging premium</div><div class="ma-pkg-feat"><span>\u2726</span> Pi\u00e8ce num\u00e9rot\u00e9e</div><div class="ma-pkg-feat"><span>\u2726</span> Livraison rapide</div><div class="ma-pkg-feat"><span>\u2726</span> \u00c9dition limit\u00e9e</div></div></div><div class="ma-pkg-visual"><div class="ma-pkg-img-wrap"><img src="https://malangeclothing.com/cdn/shop/files/55A0849-2_2a6d66c2-9e62-4f19-a02a-94078b672f59.jpg?v=1737331268" alt="MalAnge" loading="lazy"></div></div></div>`;
  const footer=$('footer,.site-footer');
  if(footer)footer.insertAdjacentElement('beforebegin',sec);
}

function initMobileZoom(){
  if(window.innerWidth>768)return;
  $$('.product-images img,.product__media img').forEach(img=>{
    const ov=document.createElement('div');ov.className='ma-zoom-overlay';
    ov.innerHTML=`<img src="${img.src}" alt="${img.alt}"><button class="ma-zoom-close">\u00d7</button>`;
    document.body.appendChild(ov);
    on(img,'click',()=>ov.classList.add('is-open'));
    on(ov.querySelector('.ma-zoom-close'),'click',()=>ov.classList.remove('is-open'));
    on(ov,'click',e=>{if(e.target===ov)ov.classList.remove('is-open');});
  });
}

function init(){
  initNavCleanup();
  // initSocialProofTicker supprim\u00e9 : \u00e9tait la source du bandeau WORLDWIDE parasite
  initPackagingSection();
  initMobileZoom();
  if(isPage('product')){setTimeout(initFAQ,400);setTimeout(initBundleSuggestion,600);}
}

if(document.readyState!=='loading')init();
else document.addEventListener('DOMContentLoaded',init);
})();